import { GQLProductTileFragment } from '@theprintbar/graphql';
import { ImageSize, cn, getProductImageUrl } from '@theprintbar/shared';

interface ProductTileImageProps {
	product: GQLProductTileFragment;
	webDomain?: string;
	size?: ImageSize;
}

export function ProductImage({ product, webDomain, size = ImageSize.Large }: ProductTileImageProps) {
	return (
		<div
			className={cn(
				'relative overflow-hidden shadow-lg rounded-3xl aspect-[3/4] bg-white-mid flex flex-col justify-center border border-blue',
			)}
		>
			<div className="absolute inset-0">
				<img
					loading="lazy"
					src={getProductImageUrl({ product, productCode: product.code, size, webDomain })}
					alt={`${product.name} Model image`}
					className={cn('absolute h-full w-full object-cover object-center')}
				/>
			</div>
		</div>
	);
}
